import React from 'react'
import styled from 'styled-components';
import ActionsReadOnlyEmptyStateSearch from './ActionsReadOnlyEmptyStateSearch';

const Container = styled.div`

    width:100%;
    display:flex;
    flex-direction:column;
    align-items:center;
    color:#858585;
`

const SVGContainer = styled.div`
    padding-top:50px
`;

const TitleContainer = styled.div`
    padding-bottom:20px;
    font-size:23px;
    font-weight:500;
`;

const SubtitleContainer = styled.div`
    padding-bottom:40px;
    font-size:20px;
    font-weight:400;
`;

const SelectContainer = styled.div`
    width:300px
`;


export default function ActionsReadOnlyEmptyState({context}) {
    return (
        <Container>
            <SVGContainer>
                <img width="600px" src="../icons/ReadOnlyEmptyState.svg"/>
            </SVGContainer>
            <TitleContainer>
                You're not assigned to any projects yet.
            </TitleContainer>
            <SubtitleContainer>
                You can explore projects, but you won't be able to make any modifications.
            </SubtitleContainer>
            <SelectContainer>
                <ActionsReadOnlyEmptyStateSearch context={context}/>
            </SelectContainer>

        </Container>
    )
}
